// @flow

import PageContainer from '../common/PageContainer';
import { topBarHeight } from '../../components/navigation/NavigationBar';
import { useTheme } from '@mui/material';

const EDGE_AGROLOG_TOOL_URL = 'https://edge.agrolog.io/';

const Edge = (): React$Node => {
  const theme = useTheme();

  return (
    <PageContainer>
      <iframe
        src={`${EDGE_AGROLOG_TOOL_URL}`}
        style={{
          width: '100%',
          height: `calc(${window.innerHeight}px - ${theme.spacing(topBarHeight + 2)})`,
          border: 0
        }}
      />
    </PageContainer>
  );
};

export default Edge;
